'use client';

import { useState, useEffect } from 'react';
import { SurveyPopup } from './survey-popup'
import { SurveyMain } from './survey-main';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountStatus } from '@/hooks/query/account';

export const PlayerSurvey = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { data: actStatus } = useAccountStatus();
	const [showSurveyForm, setShowSurveyForm] = useState<boolean>(false);

	useEffect(() => {
		const showPlayerSurveyForm = (() => setShowSurveyForm(true)) as EventListener;
		document.addEventListener('show-player-survey-form', showPlayerSurveyForm);
		return () => {
			document.removeEventListener('show-player-survey-form', showPlayerSurveyForm);
		};
	}, []);

	const isShow = SiteConfigsData?.EnableGalaxyCustomerSurvey && actStatus === 2;

	return isShow ? (
		<>
			<SurveyPopup />
			{showSurveyForm ?
				<SurveyMain
					showSurveyForm={showSurveyForm}
					setShowSurveyForm={setShowSurveyForm}
				/> : null}
		</>
	) : null;
};